var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.004,
    height: 20,
    viewBox: "0 0 20.004 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instagram-brands",
    d: "M9.929,36.7a5.128,5.128,0,1,0,5.128,5.128A5.12,5.12,0,0,0,9.929,36.7Zm0,8.461a3.334,3.334,0,1,1,3.334-3.334,3.34,3.34,0,0,1-3.334,3.334Zm6.534-8.671a1.2,1.2,0,1,1-1.2-1.2A1.193,1.193,0,0,1,16.463,36.487Zm3.4,1.214a5.919,5.919,0,0,0-1.616-4.191A5.958,5.958,0,0,0,14.053,31.9c-1.651-.094-6.6-.094-8.252,0a5.949,5.949,0,0,0-4.191,1.611A5.938,5.938,0,0,0,0,37.7C-.1,39.348-.1,44.3,0,45.949a5.919,5.919,0,0,0,1.616,4.191A5.965,5.965,0,0,0,5.8,51.755c1.651.094,6.6.094,8.252,0a5.919,5.919,0,0,0,4.191-1.616,5.958,5.958,0,0,0,1.616-4.191C19.953,44.3,19.953,39.353,19.859,37.7ZM17.726,47.72a3.375,3.375,0,0,1-1.9,1.9c-1.317.522-4.44.4-5.9.4s-4.583.116-5.9-.4a3.375,3.375,0,0,1-1.9-1.9c-.522-1.317-.4-4.44-.4-5.9s-.116-4.583.4-5.9a3.375,3.375,0,0,1,1.9-1.9c1.317-.522,4.44-.4,5.9-.4s4.583-.116,5.9.4a3.375,3.375,0,0,1,1.9,1.9c.522,1.317.4,4.44.4,5.9S18.248,46.408,17.726,47.72Z",
    transform: "translate(0.075 -31.825)",
    fill: "#2f77b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBrands);
export default __webpack_public_path__ + "static/media/instagram-brands.ddedb67d4a283175a90455d67f3d1ba6.svg";
export { ForwardRef as ReactComponent };